<template>
  <mdb-container :class="currentGroup && $route.params.groupId ? '' : 'gp-has-header'" v-if="details">
    <banner-small :group="currentGroup" :title="details.page.name" v-if="currentGroup && $route.params.groupId"/>
    <mdb-card class="mb-4 animated slideInRight" v-if="details.page.pageText">
      <mdb-card-body class="text-left" v-html="details.page.pageText">
      </mdb-card-body>
    </mdb-card>

    <mdb-row>
      <div :key="i" class="col-lg-4 col-md-12 d-flex align-self-stretch" v-for="(card,i) in details.cards">
        <mdb-card class="mb-4 animated slideInLeft" style="width:100%">
          <mdb-card-image v-if="card.topImage" :src="card.topImage"></mdb-card-image>
          <mdb-card-header v-if="!card.topImage" class="text-center">
            {{ card.name }}
          </mdb-card-header>
          <mdb-card-body>
            <div style="width:100%;" v-html="card.pageText"></div>
          </mdb-card-body>
        </mdb-card>
      </div>
    </mdb-row>

  </mdb-container>
</template>

<script>
import api from '../services/groupsPlaceApi.js'
import {
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbRow
} from 'mdbvue';
import bannerSmall from "./group/BannerSmall";

export default {
  name: 'Documents',
  components: {
    mdbContainer,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbRow,
    mdbCol,
    bannerSmall
  },
  data() {
    return {
      details: null
    }
  },
  computed: {
    currentGroup: function () {
      return this.$store.state.currentGroup
    }
  },
  async mounted() {
    let url = "/card/show/" + this.$route.params.id
    if (this.$route.params.groupId) {
      await api.groupBasics(this.$route.params.groupId, "member")
      url += "?group=" + this.$route.params.groupId
    }
    await this.$store.dispatch("setExecuting", false)
    api.get(url).then(
      (results) => {
        this.details = results.data
      },
      (error) => {
        if (error.response.status == 404) this.$router.push({path: '/404', query: {redirect: this.$route.fullPath}})
        else if (error.response.status == 403 || error.response.status == 401) this.$router.push("/403")
        else this.$notify.error({message: "Error fetching page.", timeOut: 5000})
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  }
};
</script>
